import { isToday } from 'date-fns'
import qs from 'qs'
import { useEffect } from 'react'

import commonRepo from '@/repository/common.repo'
import WebviewService from '@/service/webview.service'
import { customerMessengerService } from '@/utils/modules/CustomerMessenger/CustomerMessengerService'
import {
  buildReportContext,
  resolveReportPlatform,
  toReportTags,
} from '@/utils/modules/errorReporting/reportContext'
import { reporter } from '@/utils/modules/errorReporting/reporter'
import { mixpanelClient } from '@/utils/trackings/mixpanel'
import { isElectronApp } from '@/utils/trackings/mixpanelConfig'
import { convertAcademyAndTeacherToGlobalEventProperty } from '@/utils/trackings/schema/globalEventProperties.schema'
import { convertAcademyToUserProperties } from '@/utils/trackings/schema/userProperties.schema'

export const useDataTracking = () => {
  useEffect(() => {
    if (commonRepo.academy && commonRepo.user) {
      mixpanelClient.identify(commonRepo.academy.academyId)

      mixpanelClient.setGlobalEventProperty({
        ...convertAcademyAndTeacherToGlobalEventProperty({
          academy: commonRepo.academy,
          teacher: commonRepo.user,
        }),
        챗봇_켜기: customerMessengerService.enabled,
      })

      mixpanelClient.setUserProperty({
        ...convertAcademyToUserProperties({
          academy: commonRepo.academy,
        }),
      })

      const reportContext = buildReportContext({
        user: commonRepo.user,
        academy: commonRepo.academy,
        isSchoolflat: commonRepo.isSchoolflat,
        platform: resolveReportPlatform({
          isElectron: isElectronApp(),
          isAppWebview: WebviewService.isAppAndroid || WebviewService.isAppIpad,
        }),
      })
      reporter.setUser(reportContext.user)
      reporter.setTags(toReportTags(reportContext.fw))
    }
  }, [commonRepo.academy, commonRepo.user])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params: any = qs.parse(window.location.search, { ignoreQueryPrefix: true })

    if ('s' in params && typeof params.s === 'string') {
      params['당일접속여부'] = isToday(parseInt(params.s))
    }

    mixpanelClient.track('T10-01_로그인화면_수동', params)
  }, [])
}
